import { IIconProps } from '../../types/IconProps.interface'

export const IconCashOut = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 32 32'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 10C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H6C4.89543 12 4 12.8954 4 14V26C4 27.1046 4.89543 28 6 28H26C27.1046 28 28 27.1046 28 26V14C28 12.8954 27.1046 12 26 12H23C22.4477 12 22 11.5523 22 11C22 10.4477 22.4477 10 23 10H26C28.2091 10 30 11.7909 30 14V26C30 28.0713 28.4256 29.774 26.4082 29.9785L26 30H6L5.5918 29.9785C3.70869 29.7876 2.2124 28.2913 2.02148 26.4082L2 26V14C2 11.7909 3.79086 10 6 10H9Z'
        fill={color}
      />
      <path
        clipRule='evenodd'
        d='M16 16C18.2091 16 20 17.7909 20 20C20 22.2091 18.2091 24 16 24C13.7909 24 12 22.2091 12 20C12 17.7909 13.7909 16 16 16ZM16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18Z'
        fill={color}
        fillRule='evenodd'
      />
      <path
        d='M8 18C9.10457 18 10 18.8954 10 20C10 21.1046 9.10457 22 8 22C6.89543 22 6 21.1046 6 20C6 18.8954 6.89543 18 8 18Z'
        fill={color}
      />
      <path
        d='M24 18C25.1046 18 26 18.8954 26 20C26 21.1046 25.1046 22 24 22C22.8954 22 22 21.1046 22 20C22 18.8954 22.8954 18 24 18Z'
        fill={color}
      />
      <path
        d='M16 0C16.5523 0 17 0.447715 17 1V9.99805L19.4004 8.19922C19.8422 7.86841 20.4696 7.95882 20.8008 8.40039C21.1316 8.84218 21.0412 9.46957 20.5996 9.80078L17.1992 12.3496C16.4882 12.8826 15.5117 12.8826 14.8008 12.3496L11.4004 9.80078C10.9589 9.46957 10.8685 8.84216 11.1992 8.40039C11.5304 7.9588 12.1578 7.86847 12.5996 8.19922L15 9.99805V1C15 0.447754 15.4478 6.33893e-05 16 0Z'
        fill={color}
      />
    </svg>
  )
}
